import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { appInsights } from "./AppInsights";
import config from "./config.json";

const useTrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const userAuthenticatedId = sessionStorage.getItem("authId");
    const userName = sessionStorage.getItem("userName");
    if (userName && userAuthenticatedId) {
      appInsights.setAuthenticatedUserContext(userAuthenticatedId, userName);
    }
    const trackPageView = () => {
      const pageTitle = document.title || "Unknown Page";
      const pagePath = location.pathname + location.search;
      const fullTitle =
        pageTitle + " - " + location.pathname.replace(/\//g, "");
      if (pagePath?.trim() !== '/') {
        appInsights.trackPageView({ name: fullTitle, uri: pagePath });
      }
    };
    const instrumentationKey = config.instrumentationKey;
    if (instrumentationKey) {
      trackPageView();
    }
  }, [location]);
};

export default useTrackPageView;
